import { Component, HostListener } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';

@Component({
  selector: 'cookie-notice',
  templateUrl: './cookie-notice.component.html',
  styleUrls: ['./cookie-notice.component.sass'],
  animations: [
  	trigger('coockieConsent', [
  			state('false', style({
  				marginTop: '0',
  				opacity: '1'
  			})),
  			state('true', style({
  				marginTop: '-40px',
  				opacity: '0'
  			})),
  			transition('false=>true', animate('1250ms')),
  			transition('true=>false', animate('1000ms'))
  		]
  	)
  ]
})
export class CookieNoticeComponent {

	isConsented = false;
	consentValue: string = this.isConsented.toString();

  constructor() {
  	this.setConsent();
  }

  @HostListener('window:scroll', ['$event']) scrollPosition() {

    const scrollPosition = window.pageYOffset;
    const start = 200;

    if (scrollPosition >= start) {
      this.onAlertClose();
    }
  }

  public onAlertClose() {
  	this.setCS('COOKIE_CONSENT', true);
  	this.setConsent();
  }

  private setCS(_name: string, _value: boolean) {
  	return localStorage.setItem(_name, `${_value}`);
  }

  private getCS(_name: string) {
  	return localStorage.getItem(_name);
  }

  private resetCS() {
  	localStorage.clear();
  	this.setConsent();
  }

  private setConsent() {
  	if (this.getCS('COOKIE_CONSENT')) {
  		this.isConsented = (this.getCS('COOKIE_CONSENT') == 'true');
  	} else {
  		this.isConsented = false;
  	}
  	this.consentValue = this.isConsented === false ? 'false' : 'true';
  }
}
